import { Injectable } from '@angular/core';
import { BaseErrorHandlerModel, ExtendedServerErrorResponse, LoggingService } from '@app-core';

@Injectable({
    providedIn: 'root',
})
export class ProgressEventHandlerService extends BaseErrorHandlerModel {
    errorStateService: any;
    override handle(error: ExtendedServerErrorResponse): void {
        LoggingService.log('ProgressEventHandlerService::handle:', error);
        this.router.navigate(['/error']);
    }
}
